interface JSONAPIError {
  code: Maybe<string>;
  message: string;
}

interface APIError {
  code: Maybe<string>;
  kind: 'APIError';
  message: string;
}

const fromJSON = (jsonAPIError: JSONAPIError): APIError => ({
  code: jsonAPIError.code,
  kind: 'APIError',
  message: jsonAPIError.message,
});

export default APIError;
export { APIError, JSONAPIError, fromJSON };
